import { takeLatest } from "redux-saga/effects";
import { uploadImageAction } from "./slices";
import { uploadImageWorker } from "./workers";

const uploadWatcher = [takeLatest(uploadImageAction, uploadImageWorker)];

export default uploadWatcher;
